import React from "react";
import Image from "next/image";
import Link from "next/link";

interface MentorCardProps {
    name: string;
    role: string;
    bio: string;
    formationsCount: number;
    tags: string[];
    image: string;
}

const MentorCard: React.FC<MentorCardProps> = ({ name, role, bio, formationsCount, tags, image }) => (
    <div className="flex flex-col gap-4.5 items-center justify-between text-center w-full lg:max-w-71.5 h-120">
        <div className="flex flex-col items-center gap-4.5">
            <div className="relative w-24 h-24 rounded-full overflow-hidden ">
                <Image
                    src={image}
                    alt={name}
                    fill
                    className="object-cover"
                    unoptimized={image.startsWith("http")}
                />
            </div>

            <div>
                <h3 className="font-bold text-[15px] leading-5 text-[#1B365E]">{name},</h3>
                <p className="text-[12px] text-[#1B365E] font-normal leading-5 ">{role}</p>
            </div>

            <p className="text-[12px] font-normal leading-5 text-[#1D1D1D]">
                {bio}
            </p>
        </div>


        <div className="w-full space-y-4.5">
            <p className="font-bold text-[12px] leading-5 text-[#1B365E]">Propose {formationsCount} Formations :</p>

            <div className="flex flex-col gap-4.5 ">
                {tags.map((tag, i) => (
                    <div key={i} className="bg-[#C7F8FF] text-[#1B365E] border border-[#EFEFEF] px-4.5 py-2 rounded-full text-[12px] leading-5 font-normal tracking-[0.2px]">
                        {tag}
                    </div>
                ))}
            </div>

            <Link href="#" title="Découvrez ses formations" className="inline-block text-[#1B365E] font-bold text-[15px] leading-4.5 hover:underline transition-all">
                Découvrez ses formations
            </Link>
        </div>
    </div>
);


export default MentorCard;
